module.exports = __webpack_public_path__ + "img/tag-icon.c209cb32.svg";